import { render } from "./TemplatesPage.vue?vue&type=template&id=37714bf8&scoped=true"
import script from "./TemplatesPage.vue?vue&type=script&lang=js"
export * from "./TemplatesPage.vue?vue&type=script&lang=js"

import "./TemplatesPage.vue?vue&type=style&index=0&id=37714bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37714bf8"]])

export default __exports__